import axios from '@/framework/http/axios'
const model = '/api/category';
let getUrl = `${model}/detail`;
let saveUrl = `${model}/add`;
let searchUrl = `${model}/get`;
let updateUrl = `${model}/update`;
let deleteUrl = `${model}/delete`;
let getProductByCategoryUrl = `${model}/getProductByCategory` //按类别返回商品
export function get(param, callback) {
  axios({
    url: getUrl,
    method: 'get',
    params: param
  }).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}

export function searchList(param, callback) {
  axios({
    url: searchUrl,
    method: 'get',
    params: param
  }).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}


export function update(param, callback) {
  axios.post(updateUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}

export function save(param, callback) {
  axios.post(saveUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}

export function search(param, callback) {
  axios({
    url: searchUrl,
    method: 'get',
    params: param
  }).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}
export function getProductByCategory(param, callback) {
  axios({
    url: getProductByCategoryUrl,
    method: 'get',
    params: param
  }).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}

export function categorySearch(param, callback) {
  axios.post(searchUrl, param).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}

export function del(param, callback) {
  axios({
    url: deleteUrl,
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    data: param
  }).then(data => {
    if (data !== undefined && data !== '' && data !== null) {
      // callback when data is exist
      callback(data)
    }
  })
}



// WEBPACK FOOTER //
// ./src/service/category.js